'use client';

import { useExperiments } from '@alltrails/experiments';
import AppInstallSectionCondensed from './AppInstallSectionCondensed';
import AppInstallSectionStacked from './AppInstallSectionStacked';

const AppInstallSection = () => {
  const experiments = useExperiments();
  const variant = experiments?.['web-growth-rm-homepage-app-install-module']?.value;

  if (variant === 'stacked') {
    return <AppInstallSectionStacked />;
  }

  return <AppInstallSectionCondensed />;
};

export default AppInstallSection;
export { default as AppInstallSectionCondensed } from './AppInstallSectionCondensed';
export { default as AppInstallSectionStacked } from './AppInstallSectionStacked';
